export class FetchTimeoutError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'FetchTimeoutError';
  }
}

export async function fetchWithTimeout(
  input: RequestInfo | URL,
  init: RequestInit | undefined,
  timeoutMs: number,
  timeoutMessage: string
): Promise<Response> {
  let timeoutId: number | null = null;

  const timeoutPromise = new Promise<Response>((_, reject) => {
    timeoutId = window.setTimeout(() => {
      reject(new FetchTimeoutError(timeoutMessage));
    }, timeoutMs);
  });

  try {
    return await Promise.race([
      fetch(input, init),
      timeoutPromise,
    ]);
  } finally {
    if (timeoutId !== null) {
      window.clearTimeout(timeoutId);
    }
  }
}
